import { PropsWithChildren } from 'react';

export const DetailSectionLabel = (props: PropsWithChildren) => {
  const { children } = props;

  return (
    <p className="text-muted-foreground text-xs font-medium">{children}</p>
  );
};
